const validate = (value, args) => {
  let result = false
  if (typeof value === 'number') {
    value = value.toString()
  } else if (typeof value !== 'string') {
    value = ''
  }
  if (!!value.length && /[0-9]/.test(value) && value.length === 15) {
    const n15 = parseInt((parseInt(value.slice(0, -1)) % 13).toString().slice(-1))
    if (n15 === parseInt(value[14])) {
      result = true
    }
  }
  return result
}

export default {
  validate
}
